import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';

import LandingPage from './pages/landing/LandingPage';
import DocsPage from './pages/landing/DocsPage';
import LoginPage from './pages/auth/LoginPage';
import AdminLayout from './components/layout/AdminLayout';
import DashboardPage from './pages/admin/DashboardPage';
import LojistaDashboardPage from './pages/admin/LojistaDashboardPage';
import UsersPage from './pages/admin/UsersPage';
import FreightPage from './pages/admin/FreightPage';
import QuotePage from './pages/admin/QuotePage';
import TokensPage from './pages/admin/TokensPage';
import LabelPage from './pages/admin/LabelPage';
import NotFoundPage from './pages/NotFoundPage';

function PrivateRoute({ children, adminOnly = false, permKey = null }) {
  const { user, token } = useAuthStore();
  if (!token || !user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/admin/dashboard" replace />;
  if (permKey && user.role !== 'admin' && user.permissions?.[permKey] === false) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}

function DashboardRouter() {
  const { user } = useAuthStore();
  return user?.role === 'admin' ? <DashboardPage /> : <LojistaDashboardPage />;
}

function PublicRoute({ children }) {
  const { token, user } = useAuthStore();
  if (token && user) return <Navigate to="/admin/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { fontFamily: 'Inter, sans-serif', fontSize: '14px' },
        }}
      />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/docs" element={<DocsPage />} />

        <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />

        <Route path="/admin" element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardRouter />} />
          <Route path="users" element={<PrivateRoute adminOnly><UsersPage /></PrivateRoute>} />
          <Route path="freight" element={<PrivateRoute permKey="fretes"><FreightPage /></PrivateRoute>} />
          <Route path="correios" element={<PrivateRoute permKey="simulador_fretes"><QuotePage /></PrivateRoute>} />
          <Route path="etiquetas" element={<PrivateRoute permKey="etiquetas"><LabelPage /></PrivateRoute>} />
          <Route path="tokens" element={<PrivateRoute permKey="tokens_api"><TokensPage /></PrivateRoute>} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
